import { requestWithInstrumentation } from './requestWithInstrumentation';
import { applyOfficeContext } from './utilities/applyOfficeContext';
export function requestWithOfficeContext(eventName, requestConfig, officeHomeApiRoot, officeCorrelationId, strategy, populateRequestEvent, onUploadProgress, onDownloadProgress, cancellationToken, timeoutInMs) {
    // Append headers and add query params to requests going to OfficeHome endpoint
    // IMPORTANT: Don't use the .includes() function to check for the OfficeHome endpoint as some requests to other services
    // may have officeHomeApiRoot value somewhere in the URL.
    // IMPORTANT: Check against value with trailing slash added to account for the case when officeHomeApiRoot is empty string
    // indicating that API root is on path root.
    var officeHomeApiRootWithTrailingSlash = officeHomeApiRoot + "/";
    if (requestConfig.url.startsWith('http') &&
        !officeHomeApiRootWithTrailingSlash.startsWith('http')) {
        officeHomeApiRootWithTrailingSlash = window.location.origin + "/" + officeHomeApiRootWithTrailingSlash;
    }
    if (requestConfig.url.lastIndexOf(officeHomeApiRootWithTrailingSlash, 0) ===
        0) {
        applyOfficeContext(requestConfig, officeCorrelationId);
    }
    return requestWithInstrumentation(eventName, requestConfig, strategy, populateRequestEvent, onUploadProgress, onDownloadProgress, cancellationToken, timeoutInMs);
}
//# sourceMappingURL=requestWithOfficeContext.js.map